module.exports = __webpack_public_path__ + "static/media/pdf.1fdbf463.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/pdf.svg
// module id = 215
// module chunks = 0